import React, { useContext } from "react";
import PropTypes from "prop-types";
import { TopNav } from "../../components/Nav/TopNav";
import ProfileIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "../../components/Icons/LogoutIcon";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { visionURL } from "../../config/environment";
import { profile } from "../../routes/LearningCenterRoutes";
import { stopImpersonate } from "../../services/impersonationsService";
import AppContext from "../../context/AppContext";

const logoutUrl = `${visionURL}/users/sign_out`;
let stopImpersonateUrl = "";

const getProfileDropdownOptions = t => [
  {
    title: t("learningCenterTopNav.profileDropdownOptions.profile"),
    icon: <ProfileIcon />,
    href: profile
  },
  {
    title: t("learningCenterTopNav.profileDropdownOptions.logout"),
    icon: <LogoutIcon />,
    href: logoutUrl
  }
];

const LearningCenterTopNav = ({
  logo,
  logoStyle,
  learningCenterCaption,
  unreadMessages,
  currentUser,
  currentPath
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { mobileNavbarOpen, setMobileNavbarOpen } = useContext(AppContext);

  stopImpersonateUrl = currentUser.isImpersonate
    ? `${visionURL}/lms_admin/impersonations/${currentUser.id}`
    : "";
  const dropdownOptions = getProfileDropdownOptions(t);

  if (currentUser.isImpersonate) {
    dropdownOptions.push({
      title: t("learningCenterTopNav.profileDropdownOptions.stopImpersonating"),
      icon: <LogoutIcon />,
      href: stopImpersonateUrl
    });
  }

  let numNotifications = unreadMessages ? unreadMessages.length : 0;
  const firstName = currentUser.firstName;
  const lastName = currentUser.lastName;
  let avatarUrl =
    currentUser && currentUser.avatarUrl ? currentUser.avatarUrl : null;

  const handleProfileDropdownOptionClick = ({ href }) => {
    if (href === logoutUrl) {
      window.location = logoutUrl;
    } else if (href === stopImpersonateUrl) {
      stopImpersonate(currentUser.id);
    } else {
      dispatch(push(profile));
    }
  };

  const handleMenuToggle = () => {
    setMobileNavbarOpen(!mobileNavbarOpen);
  };

  return (
    <TopNav
      handleMenuToggle={handleMenuToggle}
      numNotifications={numNotifications}
      logo={logo}
      logoStyle={logoStyle}
      firstName={firstName}
      lastName={lastName}
      learningCenterCaption={learningCenterCaption}
      currentUser={currentUser}
      currentPath={currentPath}
      avatarUrl={avatarUrl}
      unreadMessages={unreadMessages}
      profileDropdownOptions={dropdownOptions}
      onProfileDropdownOptionClick={handleProfileDropdownOptionClick}
    />
  );
};

export default LearningCenterTopNav;

LearningCenterTopNav.propTypes = {
  handleMenuToggle: PropTypes.func,
  logo: PropTypes.string,
  currentPath: PropTypes.string,
  logoStyle: PropTypes.string,
  learningCenterCaption: PropTypes.string
};
